// actions.js
// Action types for career data fetching request, success, and failure
export const FETCH_CAREER_REQUEST = "FETCH_CAREER_REQUEST";
export const FETCH_CAREER_SUCCESS = "FETCH_CAREER_SUCCESS";
export const FETCH_CAREER_FAILURE = "FETCH_CAREER_FAILURE";

// Action creator for career data fetching request
export const fetchCareerRequest = (payload) => ({
  type: FETCH_CAREER_REQUEST,
  payload
});

// Action creator for career data fetching success
export const fetchCareerSuccess = (isCareerItem) => ({
  type: FETCH_CAREER_SUCCESS,
  payload: isCareerItem,
});

// Action creator for career data fetching failure
export const fetchCareerFailure = (error) => ({
  type: FETCH_CAREER_FAILURE,
  payload: error,
});
